import React from "react";
import "./Panel.css";

const Panel = ({
  as: Component = "section",
  ariaLabel,
  className = "",
  bodyClassName = "",
  bodyProps = {},
  children,
  depth,
  media,
  mediaContent = null,
  mediaClassName = "",
  mediaStyle,
  mediaProps = {},
  overlay = false,
  overlayClassName = "",
  overlayStyle,
  overlayProps = {},
  ...rest
}) => {
  const sectionClassName = ["panel", className].filter(Boolean).join(" ");
  const bodyClassNames = ["panel-body", bodyClassName].filter(Boolean).join(" ");

  const hasMedia = Boolean(media) || Boolean(mediaContent) || Boolean(mediaClassName);
  const hasOverlay = Boolean(overlay) || Boolean(overlayClassName) || Boolean(overlayStyle);

  const resolvedMediaStyle = {
    ...(typeof media === "string" ? { backgroundImage: `url(${media})` } : {}),
    ...mediaStyle,
  };

  return (
    <Component className={sectionClassName} aria-label={ariaLabel} {...rest}>
      {hasMedia && (
        <div
          className={["panel-bg", mediaClassName].filter(Boolean).join(" ")}
          data-depth={typeof depth === "number" ? depth : undefined}
          style={resolvedMediaStyle}
          {...mediaProps}
        >
          {typeof media === "string" ? null : media}
          {mediaContent}
        </div>
      )}

      {hasOverlay && (
        <div
          className={["panel-overlay", overlayClassName].filter(Boolean).join(" ")}
          style={overlayStyle}
          {...overlayProps}
        />
      )}

      <div className={bodyClassNames} {...bodyProps}>
        {children}
      </div>
    </Component>
  );
};

export default Panel;
